import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CampaignConfig } from '../../services/campaign.service';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Component({
  selector: 'app-campaign-banner',
  standalone: true,
  imports: [CommonModule], // RouterLink removed since we'll route programmatically to track it
  templateUrl: './campaign-banner.component.html',
  styleUrl: './campaign-banner.component.css'
})
export class CampaignBannerComponent {
  @Input() config!: CampaignConfig;
  isVisible = false;

  constructor(private router: Router, private analytics: Analytics) {}

  ngOnInit() {
    const bannerSeen = sessionStorage.getItem(`banner_seen_${this.config.slug}`);
    if (!bannerSeen) {
      this.isVisible = true;
    }
  }

  closeBanner() {
    this.isVisible = false;
    sessionStorage.setItem(`banner_seen_${this.config.slug}`, 'true');
  }

  onBannerClick() {
    // Log the tracking event
    logEvent(this.analytics, 'campaign_banner_click', {
      campaign_slug: this.config.slug,
      campaign_title: this.config.title
    });

    // Navigate to the campaign
    this.router.navigate(['/campaign', this.config.slug]);
    this.closeBanner();
  }
}
